<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'
import { string } from 'yup'
import { stringErr } from '@/constants'
import { postConselingRequest } from '~/api/conseling-request'
import { toEnglishDigits } from '~/utils/to-english-number.util'

const phoneInputRef = useTemplateRef('phoneInput')

const validationSchema = {
  fullName: string().required(stringErr),
}

const initialValues = {
  fullName: '',
}

const isSubmitting = ref(false)

const onSubmit = async (values: { fullName: string }) => {
  const phoneComp = phoneInputRef.value
  if (!phoneComp || typeof phoneComp.inputPhoneValidate !== 'function') {
    console.warn('phone input ref not found or validatePhone not available')
    return
  }

  const result = await phoneComp.inputPhoneValidate()
  if (!result || !result.isValid) {
    return
  }

  const formData = { fullName: values.fullName, phone: toEnglishDigits(result.phone) }
  isSubmitting.value = true
  await postConselingRequest(formData.fullName, formData.phone)
  isSubmitting.value = false
  values = initialValues
}
</script>
<template>
  <section class="py-6 px-6 lg:px-24 bg-[#2626BF] w-full">
    <BaseContainer>
      <div class="flex flex-col lg:flex-row items-center gap-10">
        <img class="hidden lg:block w-full lg:w-[367px] h-[112px] -ms-2" src="/home/img/home/oneClick.svg" alt=""
          aria-hidden="true">
        <img class="block lg:hidden w-full lg:w-[153px] h-[208px]" src="/home/img/home/oneClickMobile.svg" alt=""
          aria-hidden="true">
        <div class="w-full rounded-xl bg-white flex flex-col p-6 gap-4">
          <p>برای مشاوره رایگان اطلاعات خود را وارد کنید</p>
          <UiForm :validation-schema="validationSchema" :initial-values="initialValues" @submit="onSubmit">
            <div class="flex flex-col lg:flex-row items-center gap-4">
              <div class="w-full flex flex-col lg:flex-row flex-grow items-start gap-4">
                <div class="w-full lg:w-fit flex-grow flex flex-col lg:grid lg:grid-cols-2 gap-4">
                  <UiInputText name="fullName" placeholder="نام و نام خانوادگی" />
                  <LazyUiInputPhone ref="phoneInput" placeholder="شماره واتساپ یا تلگرام" />
                </div>
                <div class="w-full lg:w-[150px] flex justify-end">
                  <UiButton id="consultation-form-btn2" class="w-full lg:w-[151px] h-[48px]" :loading="isSubmitting">
                    ارسال
                  </UiButton>
                </div>
              </div>
            </div>
          </UiForm>
        </div>
      </div>
    </BaseContainer>
  </section>
</template>
